/**
 * Türkçe tarih yardımcıları — GG.AA.YYYY görüntü / YYYY-MM-DD ISO iç format.
 * Tüm bileşenler ve API çağrıları ISO (YYYY-MM-DD) kullanmaya devam eder.
 */

export function isoToTR(iso) {
  if (!iso || typeof iso !== "string" || iso.length < 10) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  if (!y || !m || !d) return "";
  return `${d}.${m}.${y}`;
}

export function trToISO(tr) {
  if (!tr || typeof tr !== "string") return "";
  const m = tr.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!m) return "";
  return `${m[3]}-${m[2]}-${m[1]}`;
}

/** Tablo/detay göstermek için — ISO YYYY-MM-DD → GG.AA.YYYY. */
export function formatDateTR(iso) {
  return isoToTR(iso) || (iso || "");
}

/** ISO datetime (2026-02-10T18:20:00Z gibi) → "10.02.2026 21:20" */
export function formatDateTimeTR(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleString("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return String(iso); }
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
